module.exports = __webpack_public_path__ + "img/clinicProject.3645d32f.svg";